import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function Categories() {
  return (
    <section className="bg-background-100 border-y border-background-300/50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
          <div>
            <span className="text-xs font-semibold tracking-widest text-primary-400">CATEGORIES</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">六大爽点分类</h2>
            <p className="mt-2 text-sm text-foreground-600">想刷哪种爽，点进去就直接开刷</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((c) => (
            <Link
              key={c.key}
              to={`/recommend?cat=${encodeURIComponent(c.name)}`}
              className="group relative overflow-hidden rounded-lg bg-background-50 border border-background-300/50 p-6 hover:border-primary-500/40 transition-colors"
            >
              <div className="absolute -right-6 -top-6 h-24 w-24 rounded-full bg-primary-600/10 blur-2xl transition-all group-hover:bg-primary-500/20"></div>
              <div className="relative flex items-start justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-primary-500 to-primary-700 text-background-50">
                  <i className={`${c.icon} text-2xl`}></i>
                </span>
                <span className="rounded-full bg-background-100 px-3 py-1 text-xs text-foreground-600">{c.count}部</span>
              </div>
              <h3 className="relative mt-5 font-heading text-xl text-foreground-950 group-hover:text-primary-400 transition-colors">{c.name}</h3>
              <p className="relative mt-1.5 text-sm text-foreground-600">{c.desc}</p>
              <span className="relative mt-4 inline-flex items-center gap-1 text-sm text-primary-400">
                进入分类<i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}